import { render, staticRenderFns } from "./ModalIni.vue?vue&type=template&id=181c0a1e&scoped=true"
import script from "./ModalIni.vue?vue&type=script&lang=js"
export * from "./ModalIni.vue?vue&type=script&lang=js"
import style0 from "./ModalIni.vue?vue&type=style&index=0&id=181c0a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181c0a1e",
  null
  
)

export default component.exports